<template lang="html">
  <div class="login-main" @keyup.enter="onSubmit()">
    <img src="../../../assets/images/entrance-logo.png" alt="">
    <el-form ref="rulesForm" :model="form" :rules="rules" label-width="100%" label-position="top">
      <el-form-item :label="message.email" style="text-align:left">
        {{ form.email }}
      </el-form-item>
      <el-form-item  :label="message.Fl125" style="text-align:left">
        <el-col :span="24">
          <el-form-item prop="account" style="text-align:left">
            <el-input v-model="form.account"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="message.realName" style="text-align:left" prop="name" auto-complete="off">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item :label="message.pass1" style="text-align:left" prop="pass">
        <el-input type="password" v-model="form.pass"></el-input>
      </el-form-item>
      <el-form-item :label="message.pass2" style="text-align:left" prop="pass2">
        <el-input type="password" v-model="form.pass2"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="width:100%;margin-top:10px" @click="onSubmit">{{ message.register }}</el-button>
      </el-form-item>
    </el-form>
    <!-- <div class="login-register" @click="toLogin()">
      登录>>
    </div> -->
  </div>
</template>

<script>
export default {
  data () {
    var checkAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l159))
      } else if (value.length > 32) {
        return callback(new Error(this.$lang.ui.prompt.l160))
      } else if (value.length < 2) {
        return callback(new Error(this.$lang.ui.prompt.l161))
      } else {
        callback()
      }
    }
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l102))
      } else if (value.length > 32) {
        return callback(new Error(this.$lang.ui.prompt.l106))
      } else if (value.length < 2) {
        return callback(new Error(this.$lang.ui.prompt.l107))
      } else {
        callback()
      }
    }
    var checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l101))
      } else {
        callback()
      }
    }
    var checkPass2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l103))
      } else if (value !== this.form.pass) {
        callback(new Error(this.$lang.ui.prompt.l105))
      } else {
        callback()
      }
    }
    var email = this.$route.query.email
    return {
      message: {
        realName: this.$lang.ui.form.realName,
        pass1: this.$lang.ui.form.pass1,
        pass2: this.$lang.ui.form.pass2,
        Fl125: this.$lang.ui.form.l125,
        register: this.$lang.ui.form.register,
        email: this.$lang.ui.form.email
      },
      form: {
        email: email,
        name: '',
        pass: '',
        pass2: '',
        account: email.split('@')[0],
      },
      rules: {
        account: [
          { validator: checkAccount, trigger: 'blur' }
        ],
        name: [
          { validator: checkName, trigger: 'blur' }
        ],
        pass: [
          { validator: checkPass, trigger: 'blur' }
        ],
        pass2: [
          { validator: checkPass2, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
  },
  methods: {
    toLogin () {
      this.$router.push({ path: '/app/login' })
    },
    onSubmit () {
      this.$refs['rulesForm'].validate((valid) => {
        if (valid) {
          var token = this.$route.query.token
          this.$http.post('/cydex/api/v1/invite/accept', {
            'token': token,
            'user_name': this.form.name,
            'password': this.form.pass2,
            'account': this.form.account,
          })
            .then(response => {
              this.$router.push({ path: '/app/notice?mode=invite' })
            })
        }
      })
    }
  }
}
</script>

<style lang="css">
.login-main {
  position: absolute;
  display: block;
  width: 420px;
  left: 50%;
  top: 8%;
  border: 1px solid #999;
  border-radius: 8px;
  margin-left: -210px;
  padding: 35px 60px 45px 60px;
}
.login-main img {
  display: block;
  width: 96px;
  margin: 0 auto;
  margin-bottom: 5px;
}
.identifying-main {
  width: 100%;
  height: 36px;
  overflow: hidden;
}
.identifying-img {
  margin-top: -8px;
  width: 100% !important;
}
.login-register {
  position: absolute;
  bottom: 15px;
  font-size: 15px;
  right: 50px;
  cursor: pointer;
  color: #20a0ff;
}
</style>
